import { IPatchUserCommentDto, IPostUserCommentDto, IUser, IUserAppTableRule, IUserComment, TClinicSummaryResponce, TIceServer } from "../../types/types";

import {
  TQuestionnaireGroup,
  TGetUserDocumentsResponse,
  TUpdateUserDocumentStatusRequest,
  TUpdateUserRequest,
  TMainPageInfo,
  TTakeInquiryRequest,
  TGetQuestionsReportByUserId,
  TQuestionnaireData,
  TGetAllQuestionsAndOptionsResponse,
  TInsertAllAnswersRequest,
  TInsertAllAnswersQuestionsResponse,
  IcdAnalysisResult,
  IFullReportAnalysisResult,
  TAllUserQuestionnairesData,
  TGetMultipleQuestionnairesByUserIdAndCycleResponse,
  TGetMultipleQuestionnairesByUserIdAndCycleRequest,
  TAddMessageRequest,
  TGetStatusesResponse,
  TGetAllTherapistUsersResponse,
  IGenderOption,
  IChatAppointment,
  TQuestionnaireRequest,
  IPostChatAppointmentRequest,
  TUpdateChatAppointmentEntry,
  TCalendarAppointment,
  TMediaResponse,
  TDefaultReportDataResponse,
  IChatAppointmentResponse,
  TSupportMessage,
  TRRMListEntry,
  TAppointmentProgramRequest,
  TAppointmentProgramUpdate,
  TAppointment,
  TQuestionnaireContainer,
  TGoogleCalendarStatus,
  TGoogleCalendarAuthResponse,
  TGoogleCalendarAuthCallbackResponse,
  TGoogleCalendarDisconnectResponse,
  TAppointmentsResponse,
  TChangeAppointmentByCalendarRequest,
  TUnSeenAppointmentsProgram,
  TCreateAppointmentRequest,
  TSpecialization,
  TTherapistSpecialization,
  TConsentStatusResponse,
  TAnalysisData,
  TTakeAllInquiriesOfTypeRequest,
  TMeetingRecord,
  TGetUserMeetingRecordsResponse,
  TMeetingRecordStatusResponse,
  TMeetingRecordsListResponse,
  TFinalizeStreamingUploadResponse,
  TUpdateMeetingRecordAppointmentLinkRequest,
  TUpdateMeetingRecordAppointmentLinkResponse,
  TClinicalFindingsResponse,
  mapClinicalFindingsFromApi,
  IQuestionnaireCompaniesHeaders,
  ITreatmentRoom,
  TAppointmentsProgramsScheduleResponse,
  ITreatmentGroup,
  ICompanyDetails,
  TTherapistsQuestionsReportsResponse,
  TGetQuestionnaireAnswersForEditResponse,
  TTherapistQuestionnaireForAutoFill,
  TAutoFillActionReportRequest,
  TAutoFillActionReportResponse,
  IPendingReportResponce,
  TMigzarResponse,
  TGenderResponse,
  TUploadResponse,
  TClientFile,
} from "../types/user.types";
import { api } from "./api";
import { AppointmentDevice, StaffDevice } from "../types/device.types";
import {
  IAppointmentProgram,
  IAppointmentsProgramsMetaData,
  IAvailability,
  IGetUsersByCompanyIdWithRecommendsResponse,
  ITreatmentPlan,
  TAddUserRequest,
  TAppointmentsProgramsTherapist,
  TCity,
  TGetUsersByTherapistIdResponse,
  TGetUsersRequest,
  TQuestionnaireButton,
  TSetPasswordRequest,
} from "../../types/types";
import { IResponse } from "../types";
import {
  IUserResponse,
  TSendInquiryUpdateRequest,
  TUpdateInquiryStatusRequest,
} from "../types/auth.types";
import { IGetUserEntitlementsResponse, IPendingHotlineQuestionnaireResponse } from "../types/user.types";
import { ICancelAppReason, ICancelAppRequest, IPatchAppointmentRequest, IValidateAppointmentChangeRequest, IValidateAppointmentChangeResponse, ICreateAppointmentFastRequest, IProgramSessionsResponse, IProgramConfig, IConvertToSeriesRequest } from "../../pages/calendar/types/appointments.types";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateUserStatus: build.mutation<
      IUserResponse,
      { guid: string; statusId: number }
    >({
      query: ({ guid, statusId }) => ({
        url: `user/${guid}/status`,
        method: "PATCH",
        body: {
          statusId,
        },
      }),
    }),
    deleteMeetingRecords: build.mutation<void, { userId: number; recordNum?: number }>({
      query: ({ userId, recordNum }) => ({
        url: recordNum !== undefined
          ? `/Therapists/deleteRecording/${userId}/${recordNum}`
          : `/Therapists/deleteRecording/${userId}`,
        method: "DELETE",
      }),
    }),
    getUser: build.query<IUserResponse, void>({
      query: () => ({
        url: `/user`,
        method: "GET",
      }),
      providesTags: () => [{ type: "user", id: "ME" }],
    }),
    // end point for treatment sequence
    getConsentStatus: build.query<
      TConsentStatusResponse,
      { patientGuid: string }
    >({
      query: ({ patientGuid }) => ({
        url: `/therapists/consents/status`,
        method: "GET",
        params: { patientGuid },
      }),
      providesTags: (result, error, { patientGuid }) => [
        { type: "Consent", id: patientGuid },
      ],
    }),

    requestConsent: build.mutation<any, { patientGuid: string }>({
      query: ({ patientGuid }) => ({
        url: `/therapists/consents/request`,
        method: "POST",
        body: { patientUserGuid: patientGuid },
      }),
      invalidatesTags: (result, error, { patientGuid }) => [
        { type: "Consent", id: patientGuid },
      ],
    }),

    processConsent: build.mutation<
      string,
      { token: string; decision: string; patientGuid: string }
    >({
      query: ({ token, decision, patientGuid }) => ({
        url: `/therapists/consents/process`,
        method: "GET",
        params: { token, decision, patientGuid },
        responseHandler: "text",
      }),
      invalidatesTags: ["Consent"],
    }),

    getUsers: build.query<TGetAllTherapistUsersResponse, void>({
      query: () => ({
        url: `Therapists/Therapist_GetALLUsers`,
        method: "GET",
      }),
    }),
    updateUser: build.mutation<IUserResponse, TUpdateUserRequest>({
      query: ({ body, guid }) => ({
        url: `user/${guid}`,
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    }),
    updateTherapistInfo: build.mutation<
      IResponse,
      { about?: string; video?: string }
    >({
      query: ({ about, video }) => ({
        url: `therapists/updateAbout`,
        method: "POST",
        body: { about, video },
      }),
      invalidatesTags: () => [{ type: "Therapist" }],
    }),
    uploadTherapistIntroVideo: build.mutation<
      IResponse & { video: string; fileId: string },
      { form: FormData }
    >({
      query: ({ form }) => ({
        url: `therapists/profile/intro-video`,
        method: "POST",
        body: form,
      }),
      invalidatesTags: () => [{ type: "Therapist" }],
    }),
    updateTherapistIntroVideoLink: build.mutation<
      IResponse & { video: string },
      { video: string }
    >({
      query: ({ video }) => ({
        url: `therapists/profile/intro-video/link`,
        method: "PUT",
        body: { video },
      }),
      invalidatesTags: () => [{ type: "Therapist" }],
    }),
    deleteTherapistIntroVideo: build.mutation<IResponse, void>({
      query: () => ({
        url: `therapists/profile/intro-video`,
        method: "DELETE",
      }),
      invalidatesTags: () => [{ type: "Therapist" }],
    }),
    getAdminMessages: build.query<
      import("../../types/types").IAdminMessage[],
      { companyId: number }
    >({
      query: ({ companyId }) => ({
        url: `Admintech/Admin_Messages_DML/1/${companyId}/2`,
        method: "POST",
        body: {},

      }),
    }),
    takeInquiry: build.mutation<IResponse, TTakeInquiryRequest>({
      query: (body) => ({
        url: `Therapists/Therapist_TakeUserRequest`,
        method: "POST",
        body,
      }),
    }),
    takeAllInquiriesOfType: build.mutation<
      IResponse,
      TTakeAllInquiriesOfTypeRequest
    >({
      query: (body) => ({
        url: `Therapists/Therapist_SyncUserInquiriesByType`,
        method: "POST",
        body,
      }),
    }),
    updateAbout: build.mutation<
      { success: boolean },
      { body: { About?: string; Video?: string; AllowPatientBooking?: boolean } }
    >({
      query: ({ body }) => ({
        url: `/therapists/updateAbout`,
        method: "POST",
        body: JSON.stringify(body),
      }),
    }),
    getUserDocuments: build.query<TGetUserDocumentsResponse, string>({
      query: (id) => ({
        url: `/users/${id}/documents`,
        method: "GET",
      }),
    }),
    sendFile: build.mutation<IResponse, FormData>({
      query: (body) => ({
        url: `/users/docs`,
        method: "POST",
        body,
        headers: {
          "content-type": "multipart/form-data",
        },
      }),
    }),
    fetchPrescriptions: build.query<IResponse, void>({
      query: () => ({
        url: `/users/prescriptions`,
        method: "GET",
      }),
    }),
    updatePrescription: build.mutation<IResponse, string>({
      query: (prescriptionId) => ({
        url: `/users/prescriptions`,
        method: "POST",
        body: { prescriptionId },
      }),
    }),
    getMainPageInfo: build.query<TMainPageInfo, void>({
      query: () => ({
        url: `/Therapists/Therapist_GetUserInsertQuestionnaire`,
        method: "GET",
      }),
    }),
    getReportQuestionsAndOptionsByQuestionnaireId: build.query<
      TGetAllQuestionsAndOptionsResponse,
      number
    >({
      query: (questionnaireId) => ({
        url: `Questions/GetAllQuestionsAndOptionsByQuestionnaireId/${questionnaireId}`,
        method: "GET",
      }),
    }),
    getDefaultReportData: build.query<
      TDefaultReportDataResponse,
      string | number
    >({
      query: (userGuid) => ({
        url: `Therapists/Therapist_GetDefaultReport/${userGuid}`,
        method: "GET",
      }),
    }),
    getAllQuestionnairesByUserId: build.query<
      TAllUserQuestionnairesData,
      { UsersGuidId: string }
    >({
      query: ({ UsersGuidId }) => ({
        url: `Questions/GetQuestionnairesByUsersId/${UsersGuidId}`,
        method: "GET",
      }),
      providesTags: (result, error, { UsersGuidId }) => [
        { type: "Questionnaires", id: UsersGuidId },
        "Questionnaires",
      ],
    }),
    getMultipleQuestionnairesByUserIdAndCycle: build.query<
      TGetMultipleQuestionnairesByUserIdAndCycleResponse,
      TGetMultipleQuestionnairesByUserIdAndCycleRequest
    >({
      query: ({ UsersGuidId, Cycle, QuestionnaireCompaniesId }) => ({
        url: `Questions/GetMultiplesReportsByUserId/${QuestionnaireCompaniesId}/${UsersGuidId}/${Cycle}`,
        method: "GET",
      }),
    }),
    insertAllAnswersQuestions: build.mutation<
      TInsertAllAnswersQuestionsResponse,
      {
        answers: TInsertAllAnswersRequest[];
        questionnaireCompaniesId?: number;
        appointmentsId?: number;
        questionnaireCompaniesScoreUsersId?: number;
        targetUserGuid?: string;
      }
    >({
      query: ({
        answers,
        questionnaireCompaniesId = 1,
        appointmentsId = 0,
        targetUserGuid,
        questionnaireCompaniesScoreUsersId
      }) => ({
        url: `/Questions/InsertAllAnswersQuestions/${questionnaireCompaniesId}/${appointmentsId}/${questionnaireCompaniesScoreUsersId ?? 0}?targetUserGuid=${targetUserGuid ?? ""}`,
        method: "POST",
        body: JSON.stringify(answers),
      }),
      invalidatesTags: ["user"],
    }),
    insertAllAnswersQuestionsForGroup: build.mutation<
      TInsertAllAnswersQuestionsResponse,
      {
        answers: TInsertAllAnswersRequest[];
        companyId: number;
        questionnaireCompaniesId?: number;
        UsersGuidId: string;
        therapistsGuid: string;
        appointmentsId?: number;
        treatmentGroupId: number;
        questionnaireCompaniesScoreUsersId?: number;
      }
    >({
      query: ({
        answers,
        companyId,
        questionnaireCompaniesId = 1,
        appointmentsId = 0,
        therapistsGuid,
        UsersGuidId,
        treatmentGroupId,
        questionnaireCompaniesScoreUsersId
      }) => ({
        url: `/Questions/InsertAllAnswersQuestionsForGroup/${companyId}/${questionnaireCompaniesId}/${appointmentsId}/${UsersGuidId}/${therapistsGuid}/${treatmentGroupId}`,
        method: "POST",
        body: JSON.stringify(answers),
      }),
      invalidatesTags: ["user"],
    }),
    analyzeIcdCodes: build.mutation<
      IcdAnalysisResult,
      {
        icdVersion?: string;
        selectedCodes: string[];
        usersId?: string | number;
        answers: TInsertAllAnswersRequest[];
      }
    >({
      query: (params) => ({
        url: `/Questions/AnalyzeIcdCodes/${params.icdVersion ?? "ICD-10"}/${params.selectedCodes?.length ? (encodeURIComponent(
          params.selectedCodes.join(",")
        )) : "NULL"}/${params.usersId ?? "-"}`,
        method: "POST",
        body: JSON.stringify(params.answers),
      }),
    }),
    analyzeFullReport: build.mutation<
      IFullReportAnalysisResult,
      {
        answers: TInsertAllAnswersRequest[];
      }
    >({
      query: ({
        answers
      }) => ({
        url: `/Questions/AnalyzeFullReport`,
        method: "POST",
        body: JSON.stringify(answers),
      }),
    }),
    // Auto-fill action report using AI
    getTherapistQuestionnairesForAutoFill: build.query<
      TTherapistQuestionnaireForAutoFill[],
      void
    >({
      query: () => ({
        url: `/Questions/GetTherapistQuestionnairesForAutoFill`,
        method: "GET",
      }),
    }),
    autoFillActionReport: build.mutation<
      TAutoFillActionReportResponse,
      TAutoFillActionReportRequest
    >({
      query: (request) => ({
        url: `/Questions/AutoFillActionReport`,
        method: "POST",
        body: JSON.stringify(request),
      }),
    }),
    addMessageToScore: build.mutation<boolean, TAddMessageRequest>({
      query: (answers) => ({
        url: `/Score/Score_AddMessageToScore`,
        method: "POST",
        body: JSON.stringify(answers),
      }),
    }),
    getMessageByUsersIdAndCycle: build.query<
      boolean,
      { userId: string; Cycle: number }
    >({
      query: ({ userId, Cycle }) => ({
        url: `/GetMessageByUserIdAndCycle/${userId}/${Cycle}`,
        method: "GET",
      }),
    }),
    getChatAppointments: build.query<IChatAppointment[], void>({
      query: () => ({
        url: `Appointments/Appointments_GetAllAppointmentsByTherapist`,
        method: "GET",
      }),
    }),
    getChatAppointmentsByUserId: build.query<
      IChatAppointment[],
      { UsersGuidId: string; TherapistsGuidId: string }
    >({
      query: ({ UsersGuidId, TherapistsGuidId }) => ({
        url: `Appointments/Appointments_GetAppointmentsByIds/${UsersGuidId}/${TherapistsGuidId}`,
        method: "GET",
      }),
    }),
    addChatAppointment: build.mutation<
      IChatAppointmentResponse,
      { Num: number | null; body: IPostChatAppointmentRequest }
    >({
      query: ({ Num, body }) => ({
        url: `Appointments/Appointments_PostAppointments/2/${Num ?? ""}`,
        method: "POST",
        body,
      }),
    }),
    updateChatAppointment: build.mutation<
      boolean,
      { body: TUpdateChatAppointmentEntry[]; appointmentId: string | number }
    >({
      query: ({ body, appointmentId }) => ({
        url: `Appointments/${appointmentId}`,
        method: "PATCH",
        body,
      }),
    }),
    sendUserEnteredSMSToTherapist: build.query<
      { usersId: number },
      { appointmentId: string | number }
    >({
      query: ({ appointmentId }) => ({
        url: `/Appointments/Appointments_UserEnterToChat/${appointmentId}/1/0`,
        method: "POST",
      }),
    }),
    getStatuses: build.query<TGetStatusesResponse, void>({
      query: () => ({
        url: `/General/Gen_GetTableByTableName/statusrequest`,
        method: "GET",
      }),
    }),
    getMedias: build.query<TMediaResponse, void>({
      query: () => ({
        url: `/General/Gen_GetTableByTableName/medias`,
        method: "GET",
      }),
    }),
    getMigzars: build.query<TMigzarResponse, void>({
      query: () => ({
        url: `/General/Gen_GetTableByTableName/migzars`,
        method: "GET",
      }),
    }),
    getGenders: build.query<TGenderResponse, void>({
      query: () => ({
        url: `/General/Gen_GetTableByTableName/genders`,
        method: "GET",
      }),
    }),
    getAllGenders: build.query<IGenderOption[], void>({
      query: () => ({
        url: `user/getAllGenders`,
        method: "GET",
      }),
    }),
    postInquiryUpdate: build.mutation<string, TQuestionnaireRequest>({
      query: (body: TQuestionnaireRequest) => ({
        url: `/Therapists/Therapist_PostCommentsToRequest/2`,
        method: "POST",
        body,
        responseHandler: "text",
      }),
    }),
    postTherapistAvailability: build.mutation<
      IAvailability[],
      { body: IAvailability[]; guid: string }
    >({
      query: ({ body, guid }) => ({
        url: `/Therapists/TherapistsAvailability_DML/2/${guid}`,
        method: "POST",
        body: body,
      }),
    }),
    getTherapistAvailability: build.mutation<
      IAvailability[],
      { CompanyId: number; guid: string }
    >({
      query: ({ CompanyId, guid }) => ({
        url: `/Therapists/TherapistsAvailability_DML/1/${guid}`,
        method: "POST",
        body: [{ companyid: CompanyId }],
      }),
    }),
    getAllAppointments: build.query<
      TAppointmentsResponse,
      {
        therapistGuid: string;
        month: string | number;
        year: string | number;
      }
    >({
      query: ({ therapistGuid, month, year }) => ({
        url: `Appointments/Appointments_GetAppointmentsByMonthWithGoogleEvents/${therapistGuid}/${month}/${year}`,
        method: "GET",
      }),
      keepUnusedDataFor: 300, // Cache for 5 minutes
      providesTags: (result, error, { therapistGuid, month, year }) => [
        { type: 'GoogleCalendarEvents', id: `${therapistGuid}-${month}-${year}` },
        'GoogleCalendarEvents',
      ],
    }),

    // Identical to getAllAppointments but without tags to prevent auto-refetch on invalidation
    // This allows manual control via reloadMonth without triggering 429 errors from double-fetching
    getTherapistAppointments: build.query<
      TAppointmentsResponse,
      {
        therapistGuid: string;
        month: string | number;
        year: string | number;
      }
    >({
      query: ({ therapistGuid, month, year }) => ({
        url: `Appointments/Appointments_GetAppointmentsByMonthWithGoogleEvents/${therapistGuid}/${month}/${year}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0, // No cache needed as we manage it manually
    }),

    // Lightweight fetch for today's appointments (used by recording flow to link recordings)
    getTodayAppointments: build.query<
      TAppointmentsResponse,
      { therapistGuid: string }
    >({
      query: ({ therapistGuid }) => {
        const now = new Date();
        return {
          url: `Appointments/Appointments_GetAppointmentsByMonthWithGoogleEvents/${therapistGuid}/${now.getMonth() + 1}/${now.getFullYear()}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 60,
    }),

    getGoogleCalendarStatus: build.query<
      TGoogleCalendarStatus,
      void
    >({
      query: () => ({
        url: `googlecalendar/status`,
        method: "GET",
      }),
      keepUnusedDataFor: 300, // Cache for 5 minutes to prevent excessive polling
      providesTags: ['GoogleCalendarStatus'],
    }),

    getGoogleCalendarAuth: build.mutation<
      TGoogleCalendarAuthResponse,
      void
    >({
      query: () => ({
        url: `googlecalendar/auth`,
        method: "GET",
      }),
      invalidatesTags: ['GoogleCalendarEvents'], // Invalidate appointments cache after successful auth
    }),

    disconnectGoogleCalendar: build.mutation<
      TGoogleCalendarDisconnectResponse,
      void
    >({
      query: () => ({
        url: `GoogleCalendar/disconnect`,
        method: "POST",
      }),
      invalidatesTags: ['GoogleCalendarStatus', 'GoogleCalendarEvents'],
    }),

    googleCalendarOAuthCallback: build.mutation<
      TGoogleCalendarAuthCallbackResponse,
      { code: string; state: string }
    >({
      query: ({ code, state }) => ({
        url: `GoogleCalendar/callback`,
        method: "GET",
        params: { code, state },
      }),
      invalidatesTags: ['GoogleCalendarStatus', 'GoogleCalendarEvents'],
    }),

    createAppointment: build.mutation<
      TAppointment,
      {
        appointment: Partial<TCreateAppointmentRequest>;
      }
    >({
      query: ({ appointment }) => ({
        url: `/Appointments/Appointments_PostAppointments/2`,
        method: "POST",
        body: appointment,
      }),
    }),
    createAppointmentFast: build.mutation<
      TAppointment,
      {
        appointment: Partial<ICreateAppointmentFastRequest & { id?: number; appointmentsTypeId?: number; statusId?: number }>;
        repeatCount?: number;
      }
    >({
      query: ({ appointment, repeatCount = 1 }) => ({
        url: `Appointments/CreateAppointmentFast`,
        method: "POST",
        body: {
          ...appointment,
          id: 0,
          appointmentsTypeId: 1,
          statusId: 1
        },
        params: { repeatCount },
      }),
      invalidatesTags: ['GoogleCalendarEvents'],
    }),
    getAllOpenTreatmentPlans: build.mutation<
      ITreatmentPlan[],
      { companyId: number; therapistGuid: string }
    >({
      query: ({ companyId, therapistGuid }) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/1`,
        method: "POST",
        body: {
          TherapistsGuid: therapistGuid,
          companyId: companyId,
        },
      }),
    }),
    getAllOpenTreatmentPlansByUserGuid: build.mutation<
      ITreatmentPlan[],
      { companyId: number; usersGuid: string }
    >({
      query: ({ companyId, usersGuid }) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/1`,
        method: "POST",
        body: {
          TherapistsGuid: usersGuid,
          companyId: companyId,
        },
      }),
    }),
    getAvailableOpenTreatmentPlansByTherapistGuid: build.mutation<
      ITreatmentPlan[],
      { companyId: number; therapistsGuid: string }
    >({
      query: ({ companyId, therapistsGuid }) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/16`,
        method: "POST",
        body: {
          therapistsGuid,
          companyId,
        },
      }),
    }),
    updateTherapistTakingTreatmentPlan: build.mutation<
      TAppointment[],
      Partial<IAppointmentProgram>
    >({
      query: (treatmentPlan) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/6`,
        method: "POST",
        body: treatmentPlan,
      }),
    }),
    alternativeAppointmentProgramDate: build.mutation<
      TAppointment[],
      IAppointmentProgram
    >({
      query: (treatmentPlan) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/9`,
        method: "POST",
        body: treatmentPlan,
      }),
    }),

    getAllAppointmentsInProgram: build.mutation<
      TCalendarAppointment[],
      IAppointmentProgram
    >({
      query: (treatmentPlan) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/10`,
        method: "POST",
        body: treatmentPlan,
      }),
    }),
    cancleAppointmentProgram: build.mutation<
      TAppointment[],
      IAppointmentProgram
    >({
      query: (treatmentPlan) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/8`,
        method: "POST",
        body: treatmentPlan,
      }),
    }),
    postAppointmentProgram: build.mutation<
      TAppointment[],
      Partial<IAppointmentProgram>
    >({
      query: (treatmentPlan) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/2`,
        method: "POST",
        body: treatmentPlan,
      }),
    }),
    getAllUpdatesForAppointmentProgram: build.mutation<
      TAppointmentProgramUpdate[],
      number
    >({
      query: (id) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/12`,
        method: "POST",
        body: { id: id },
      }),
    }),
    changeAppointmentByCalendar: build.mutation<
      TAppointment[],
      TChangeAppointmentByCalendarRequest
    >({
      query: (body) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/13`,
        method: "POST",
        body: JSON.stringify(body),
      }),
    }),
    getAppointmentsProgramsTherapists: build.mutation<
      TAppointmentsProgramsTherapist[],
      Partial<IAppointmentProgram>
    >({
      query: (body) => ({
        url: `Appointments/AppointmentsPrograms_PostAppointments/4`,
        method: "POST",
        body,
      }),
    }),
    getAppointmentsProgramsUnavailableTherapists: build.mutation<
      TAppointmentsProgramsTherapist[],
      Partial<IAppointmentProgram>
    >({
      query: (body) => ({
        url: `Appointments/AppointmentsPrograms_PostAppointments/14`,
        method: "POST",
        body,
      }),
    }),
    updateUnavailableTherapistTakingTreatmentPlan: build.mutation<
      TAppointmentsProgramsScheduleResponse[],
      Partial<IAppointmentProgram>
    >({
      query: (treatmentPlan) => ({
        url: `/Appointments/AppointmentsPrograms_PostAppointments/15`,
        method: "POST",
        body: treatmentPlan,
      }),
    }),
    getUnSeenAppointmentsProgram: build.query<TUnSeenAppointmentsProgram, void>(
      {
        query: () => ({
          url: `/Appointments/GetUnSeenAppointmentPrograms`,
          method: "GET",
        }),
      }
    ),
    getAllMetaTables: build.query<IAppointmentsProgramsMetaData, number>({
      query: (companyId) => ({
        url: `Appointments/AppointmentsPrograms_GetAllMetaTables/${companyId}`,
        method: "GET",
      }),
    }),
    updateUnSeenAppointmentsProgram: build.query<
      TUnSeenAppointmentsProgram,
      void
    >({
      query: () => ({
        url: `/Appointments/UpdateUnSeenAppointmentsProgram`,
        method: "GET",
      }),
    }),
    sendSMSToChat: build.query<
      { usersId: number },
      {
        AppointmentId: number;
        isUser?: number;
        isTherapists?: number;
      }
    >({
      query: ({ AppointmentId, isUser, isTherapists }) => ({
        url: `/Appointments/Appointments_UserEnterToChat/${AppointmentId}/${isUser ? 1 : 0
          }/${isTherapists ? 1 : 0}`,
        method: "POST",
      }),
    }),
    uploadFile: build.mutation<
      IResponse,
      { form: FormData; usersId: number | string; type: number }
    >({
      query: ({ form, type, usersId }) => ({
        url: `/files/UploadFiles/${type}/${usersId}`,
        method: "POST",
        body: form,
      }),
    }),
    uploadUserAvatar: build.mutation<
      IResponse & { avatar: string; fileId: string },
      { form: FormData; guid: string | number }
    >({
      query: ({ form, guid }) => ({
        url: `user/${guid}/avatar`,
        method: "POST",
        body: form,
      }),
      invalidatesTags: () => [{ type: "user", id: "ME" }],
    }),
    deleteUserAvatar: build.mutation<IResponse, { guid: string | number }>({
      query: ({ guid }) => ({
        url: `user/${guid}/avatar`,
        method: "DELETE",
      }),
      invalidatesTags: () => [{ type: "user", id: "ME" }],
    }),
    postFile: build.mutation<
      TUploadResponse,
      {
        file: File;
        usersId: string | number;
        supportId?: string | number;
        type?: number;
      }
    >({
      query: ({ file, usersId, supportId, type = 2 }) => {
        const formData = new FormData();
        let fileToUpload = file;
        if (supportId) {
          const extension = file.name.split(".").pop();
          fileToUpload = new File([file], `${supportId}.${extension}`, {
            type: file.type,
          });
        }

        formData.append("file", fileToUpload);
        // Use therapist-specific upload endpoint
        return {
          url: `therapists/UploadFiles/${type}`,
          method: "POST",
          body: formData,
        };
      },
    }),
    postSupportMessage: build.mutation<
      TSupportMessage,
      Partial<TSupportMessage>
    >({
      query: (body) => ({
        url: `Admintech/Supports/CreateTicket`,
        method: "POST",
        body,
      }),
    }),
    getRRMList: build.mutation<
      TRRMListEntry[],
      { type: number; companyId: number }
    >({
      query: ({ type, companyId }) => ({
        url: `Admintech/Admin_CompanyGeneralRRM_DML/${type}/${companyId}`,
        method: "POST",
        body: [{}],
      }),
    }),
    getQuestionnaiersButtons: build.mutation<
      TQuestionnaireButton[],
      { type: number; companyId: number }
    >({
      query: ({ type, companyId }) => ({
        url: `Admintech/Admin_QuestionnaireCompaniesButtons_DML/${type}/${companyId}`,
        method: "POST",
        body: {},
      }),
    }),
    addUser: build.mutation<
      TGetUsersByTherapistIdResponse,
      {
        body: TAddUserRequest;
        companyId: number | string;
      }
    >({
      query: ({ body, companyId }) => ({
        url: `Admintech/Admin_Users_DML/2/${companyId}`,
        method: "POST",
        body,
      }),
    }),
    getUsersByCompanyIdWithRecommends: build.query<
      IGetUsersByCompanyIdWithRecommendsResponse,
      TGetUsersRequest
    >({
      query: ({
        companyId,
        fakeCompanyId = 0,
        roleId = 0,
        recommendsId = 0,
        startDate = 0,
        endDate = 0,
      }) => ({
        url: `user/GetUsersByCompanyIdWithRecommendsNew/${companyId}/${fakeCompanyId}/${roleId}/${recommendsId}/${startDate}/${endDate}`,
        method: "GET",
      }),
    }),
    changePassword: build.mutation< //for personal use
      { success: boolean },
      { currentPassword: string; newPassword: string }
    >({
      query: (body) => ({
        url: '/Admintech/account/change-password',
        method: 'POST',
        body,
      }),
    }),
    adminResetUserPassword: build.mutation< //for clients
      { success: boolean },
      { targetUserGuid: string; newPassword: string }
    >({
      query: ({ targetUserGuid, newPassword }) => ({
        url: `/Admintech/admin/users/${encodeURIComponent(targetUserGuid)}/reset-password`,
        method: 'POST',
        body: { newPassword },
      }),
    }),
    postTreatmentPlanUpdates: build.mutation<
      string,
      TAppointmentProgramRequest
    >({
      query: (body: TAppointmentProgramRequest) => ({
        url: `/Therapists/Therapist_PostCommentsToAppointmentsPrograms`,
        method: "POST",
        body: JSON.stringify(body),
        // responseHandler: "text",
      }),
    }),
    getCurrentQuestionnaireByType: build.query<
      TQuestionnaireContainer,
      {
        Guid: string;
        QuestionnaireCompaniesTypeId: number;
        IsForTherapists?: boolean;
      }
    >({
      query: ({ Guid, QuestionnaireCompaniesTypeId, IsForTherapists }) => ({
        url: `/questions/GetCurrentQuestionnaireByType/${Guid}/${QuestionnaireCompaniesTypeId}/${IsForTherapists ?? ""
          }`,
        method: "GET",
      }),
    }),
    GetUserMaxCycleByType: build.query<
      { Cycle: number },
      {
        Guid: string;
        QuestionnaireCompaniesId: number;
        QuestionnaireId: number;
      }
    >({
      query: ({ Guid, QuestionnaireCompaniesId, QuestionnaireId }) => ({
        url: `/user/GetUserMaxCycleByType/${Guid}/${QuestionnaireCompaniesId}/${QuestionnaireId}`,
        method: "GET",
      }),
    }),
    validatePassword: build.mutation<boolean, string>({
      query: (password) => ({
        url: `/user/ValidateRightPassword`,
        method: "POST",
        body: JSON.stringify(password),
      }),
    }),
    getAudioAnswerByGuidAndQuestionId: build.query<
      Blob,
      { guid: string; questionId: number }
    >({
      query: ({ guid, questionId }) => ({
        url: `/files/GetAudioAnswer/${guid}/${questionId}`,
        method: "GET",
        responseType: "blob",
        responseHandler: async (response) =>
          URL.createObjectURL(await response.blob()),
        cache: "no-cache",
      }),
    }),
    getPendingReports: build.query<IPendingReportResponce, void>({
      query: () => ({
        url: `Appointments/PendingReports`,
        method: "GET",
      }),
    }),
    therapistsSpecializationsDML: build.mutation<
      TSpecialization[],
      { list: TSpecialization[]; type: number; companyId: number }
    >({
      query: ({ list, type, companyId }) => ({
        url: `Admintech/Admin_TherapistsSpecializations_DML/${type}/${companyId}`,
        method: "POST",
        body: list,
      }),
    }),
    getUserById: build.query<
      { guid: string; userId: number; fullName?: string },
      string | number
    >({
      query: (id) => ({
        url: `/User/patientGuid/${id}`,
        method: "GET",
      }),
    }),
    therapistsSpecializations2TherapistsDML: build.mutation<
      TTherapistSpecialization[],
      {
        list: TTherapistSpecialization[];
        type: number;
        usersGuid: string;
      }
    >({
      query: ({ list, type, usersGuid }) => ({
        url: `Admintech/Admin_TherapistsSpecializations2Therapists_DML/${type}/${usersGuid}`,
        method: "POST",
        body: list,
      }),
    }),
    getClientAnalysis: build.query<TAnalysisData, number>({
      query: (questionnaireId) => ({
        url: `ai/getAnalysis/${questionnaireId}`,
        method: "GET",
      }),
    }),
    getUserMeetingRecords: build.mutation<TGetUserMeetingRecordsResponse, string>({
      query: (userGuid) => ({
        url: `/Therapists/getAllRecording/${userGuid}`,
        method: "GET",
      }),
    }),
    getMeetingRecordsList: build.query<TMeetingRecordsListResponse, string>({
      query: (userGuid) => ({
        url: `/MeetingRecords/list/${userGuid}`,
        method: "GET",
      }),
    }),
    getClinicalFindings: build.query<TClinicalFindingsResponse, string>({
      query: (userGuid) => ({
        url: `/MeetingRecords/clinical-findings/${userGuid}`,
        method: "GET",
      }),
      transformResponse: (response: Record<string, unknown>) => {
        const findings = mapClinicalFindingsFromApi(response ?? {});
        if (process.env.NODE_ENV === "development") {
          const recordNumbers = (history: { recordNumber: number }[]) => history.map((f) => f.recordNumber);
          console.debug("[ClinicalFindings] fetched", {
            suicidality: recordNumbers(findings.suicidalityHistory),
            risk: recordNumbers(findings.riskHistory),
            medication: recordNumbers(findings.medicationHistory),
            recommendations: recordNumbers(findings.recommendationsHistory),
          });
        }
        return findings;
      },
    }),
    getMeetingRecordStatus: build.query<
      TMeetingRecordStatusResponse,
      { userGuid: string; recordNumber: number }
    >({
      query: ({ userGuid, recordNumber }) => ({
        url: `/MeetingRecords/status/${userGuid}/${recordNumber}`,
        method: "GET",
      }),
    }),
    updateMeetingSummary: build.mutation<
      { success: boolean; message: string },
      { userGuid: string; recordNumber: number; meetingSummary: string }
    >({
      query: ({ userGuid, recordNumber, meetingSummary }) => ({
        url: `/MeetingRecords/updateSummary/${userGuid}/${recordNumber}`,
        method: "PUT",
        body: { meetingSummary },
      }),
    }),
    updateMeetingRecordAppointmentLink: build.mutation<
      TUpdateMeetingRecordAppointmentLinkResponse,
      TUpdateMeetingRecordAppointmentLinkRequest
    >({
      query: ({ userGuid, recordNumber, appointmentId, confirmReplace = false }) => ({
        url: `/MeetingRecords/${userGuid}/${recordNumber}/appointment-link`,
        method: "PUT",
        body: { appointmentId, confirmReplace },
      }),
    }),
    exportMeetingSummaryToPdf: build.mutation<
      { success: boolean; pdfBase64?: string; fileName?: string; errorMessage?: string },
      { userGuid: string; recordNumber: number; language?: string }
    >({
      query: ({ userGuid, recordNumber, language = "he" }) => ({
        url: `/MeetingRecords/exportSummaryToPdf`,
        method: "POST",
        body: { usersGuid: userGuid, recordNumber, language },
      }),
    }),
    // --- Pending Recording Recovery ---
    getPendingRecordingSessions: build.query<
      {
        success: boolean;
        sessions: Array<{
          sessionId: string;
          userId: number;
          // therapistId: number;
          patientName: string | null;
          patientGuid: string | null;
          mimeType: string;
          chunkCount: number;
          createdAt: string;
          lastActivityAt: string;
          recordingDurationSeconds: number | null;
          appointmentId: number | null;
          appointmentStartTime: string | null;
          sessionType?: "call" | "recording";
          sharedCallId?: string | null;
          track?: string | null;
        }>;
      },
      number | void
    >({
      query: () => ({
        url: `/MeetingRecords/pendingSessions`,
        method: "GET",
      }),
    }),
    dismissRecordingSession: build.mutation<
      { success: boolean; message: string },
      string
    >({
      query: (sessionId) => ({
        url: `/MeetingRecords/dismissSession/${sessionId}`,
        method: "DELETE",
      }),
    }),
    finalizeRecoveredSession: build.mutation<
      TFinalizeStreamingUploadResponse,
      { sessionId: string; userGuid: string; totalChunks: number; mimeType: string }
    >({
      query: ({ sessionId, userGuid, totalChunks, mimeType }) => ({
        url: `/MeetingRecords/finalizeStreamingUpload/${sessionId}`,
        method: "POST",
        body: { usersGuid: userGuid, totalChunks, mimeType },
      }),
    }),
    finalizeCallUpload: build.mutation<
      { success: boolean; recordNumber?: number; message?: string },
      {
        therapistSessionId: string;
        patientSessionId: string | null;
        sharedCallId: string;
        usersGuid: string;
        therapistTotalChunks: number;
        patientTotalChunks: number;
        therapistStartOffsetMs: number;
        patientStartOffsetMs: number | null;
        mimeType: string;
        recordingStartedAtUtc: string;
        durationSeconds: number;
        appointmentId?: number;
      }
    >({
      query: (body) => ({
        url: `/MeetingRecords/finalizeCallUpload`,
        method: "POST",
        body,
      }),
    }),
    retryMeetingRecord: build.mutation<
      { success: boolean; message?: string },
      { userGuid: string; recordNumber: number }
    >({
      query: ({ userGuid, recordNumber }) => ({
        url: `/MeetingRecords/retry/${userGuid}/${recordNumber}`,
        method: "POST",
      }),
    }),
    reprocessMeetingRecordStage: build.mutation<
      { success: boolean; stage: string; data?: string; message?: string },
      { userGuid: string; recordNumber: number; stage: "transcription" | "textAnalysis" | "audioAnalysis" | "summary" | "clinical" }
    >({
      query: ({ userGuid, recordNumber, stage }) => ({
        url: `/MeetingRecords/reprocess/${userGuid}/${recordNumber}/${stage}`,
        method: "POST",
      }),
    }),
    getProtocolsByCompany: build.query<
      IQuestionnaireCompaniesHeaders[],
      { companyId: number }
    >({
      query: ({ companyId }) => ({
        url: `/Admintech/Admin_QuestionnaireCompaniesHeaders_DML/1/${companyId}`,
        method: "POST",
        body: {},
      }),
    }),
    getCompanyAppointmentsPrograms: build.mutation<
      ITreatmentPlan[],
      { companyId: number }
    >({
      query: (body) => ({
        url: `Appointments/AppointmentsPrograms_PostAppointments/1`,
        method: "POST",
        body: { ...body, name: "" },
      }),
    }),
    getCompanyById: build.query<
      ICompanyDetails,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `Companies/GetTherapistCompanyById/${id}`,
        method: "GET",
      }),
    }),
    getTreatmentRooms: build.query<
      ITreatmentRoom[],
      { companyId: number }
    >({
      query: ({ companyId }) => ({
        url: `Admintech/Admin_TreatmentRooms_DML/1/${companyId}`,
        method: "POST",
        body: { Name: "1" },
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map((r) => ({ type: "TreatmentRooms" as const, id: r.id })),
            { type: "TreatmentRooms" as const, id: "LIST" },
          ]
          : [{ type: "TreatmentRooms" as const, id: "LIST" }],
    }),
    getTreatmentGroups: build.query<
      ITreatmentGroup[],
      { companyId: number }
    >({
      query: ({ companyId }) => ({
        url: `TreatmentGroups/getAll`,
        method: "GET",
        params: { companyId },
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map((g) => ({ type: "TreatmentGroups" as const, id: g.id })),
            { type: "TreatmentGroups" as const, id: "LIST" },
          ]
          : [{ type: "TreatmentGroups" as const, id: "LIST" }],
    }),
    getTherapistsQuestionsReports: build.query<
      TTherapistsQuestionsReportsResponse,
      void
    >({
      query: () => ({
        url: `questions/therapistQuestionsReports`,
        method: "GET",
      }),
    }),
    getQuestionnaireAnswersForEdit: build.query<
      TGetQuestionnaireAnswersForEditResponse,
      number
    >({
      query: (questionnaireCompaniesScoreUsersId) => ({
        url: `Questions/GetQuestionnaireAnswersForEdit/${questionnaireCompaniesScoreUsersId}`,
        method: "GET",
      }),
    }),
    getAllCities: build.query<TCity[], void>({
      query: () => ({
        url: `General/Gen_GetTableByTableName/Cities`,
        method: "GET",
      }),
    }),
    getClinicalUserSummary: build.query<TClinicSummaryResponce, string>({
      query: (usersGuid) => ({
        url: `user/ClinicalSummary_userSummary/${usersGuid}`,
        method: "GET",
      }),
    }), getUserTablePermissions: build.query<
      IUserAppTableRule[],
      void
    >({
      query: () => ({
        url: `Therapists/GetMyAppTableRules`,
        method: "GET",
      }),
    }),
    // Cancel Appointment - Get cancel reasons (Type=1) and cancel appointment (Type=2)
    getCancelAppReasons: build.query<
      ICancelAppReason[],
      void
    >({
      query: () => ({
        url: `Appointments/Appointments_CancelApp/1`,
        method: "POST",
        body: {
          appointmentsId: 0,
          cancelAppReasonsId: 0,
          anotherReason: "",
        },
      }),
      transformResponse: (
        response: Array<{
          Id?: number;
          CompanyId?: number;
          Reason?: string;
          IsAnother?: boolean;
          id?: number;
          companyId?: number;
          reason?: string;
          isAnother?: boolean;
        }>
      ) =>
        (response || []).map((r) => ({
          id: r.id ?? r.Id ?? 0,
          companyId: r.companyId ?? r.CompanyId ?? 0,
          reason: r.reason ?? r.Reason ?? "",
          isAnother: r.isAnother ?? r.IsAnother ?? false,
        })),
    }),
    cancelAppointment: build.mutation<
      ICancelAppReason[],
      ICancelAppRequest
    >({
      query: (body) => ({
        url: `Appointments/Appointments_CancelApp/2`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['GoogleCalendarEvents'],
    }),
    // Validate Appointment Change
    validateAppointmentChange: build.mutation<
      IValidateAppointmentChangeResponse,
      IValidateAppointmentChangeRequest
    >({
      query: (body) => ({
        url: `Appointments/ValidateChange`,
        method: "POST",
        body,
      }),
    }),
    // Patch Appointment
    /**
     * The company's devices, each marked available or taken in the requested window. A device
     * belongs to the company and not to the technician operating it, so one list serves everyone.
     */
    getCompanyDevices: build.query<
      StaffDevice[],
      | void
      | { date?: string; startTime?: string; endTime?: string; excludeAppointmentId?: number }
    >({
      query: (arg) => ({
        url: `user/GetCompanyDevices`,
        method: "GET",
        params: Object.fromEntries(
          Object.entries(arg ?? {}).filter(([, value]) => value !== undefined && value !== ""),
        ),
      }),
      transformResponse: (response: { devices?: StaffDevice[] }) => response?.devices ?? [],
    }),

    /**
     * Moves an appointment onto another machine. Separate from patchAppointment because the
     * montage is not an editable field — the server re-applies it from the patient's protocol.
     */
    updateAppointmentDevice: build.mutation<
      { success: boolean },
      { appointmentId: number; device: AppointmentDevice }
    >({
      query: ({ appointmentId, device }) => ({
        url: `Appointments/${appointmentId}/Device`,
        method: "PUT",
        body: device,
      }),
    }),

    /**
     * What this patient still owes the hotline questionnaire rule, if anything.
     *
     * The pull half of the alert. The incoming-call payload carries the same answer for a phone
     * contact, but a SignalR push reaches nobody who is offline, refreshed, or opening the
     * appointment an hour later — and a booked session has no call to carry it at all.
     *
     * Cheap by design on the server: a patient who owes nothing costs one indexed lookup, which
     * is the answer for almost everybody almost always.
     */
    getPendingHotlineQuestionnaire: build.query<
      IPendingHotlineQuestionnaireResponse,
      number
    >({
      query: (userId) => ({
        url: `HotlineQuestionnairePolicies/pending/${userId}`,
        method: "GET",
      }),
      providesTags: (_result, _error, userId) => [
        { type: "HotlineQuestionnaire" as const, id: userId },
      ],
    }),

    /**
     * Whether the session took place. The therapist is the one who knows, and this is what the
     * treatment counters read — kept apart from the payment status, which lives on the action
     * report and answers a billing question.
     */
    setAppointmentAttendance: build.mutation<
      { success: boolean; attendanceStatusId: number | null; absenceReason: string | null },
      { appointmentId: number; attendanceStatusId: number | null; absenceReason?: string | null }
    >({
      query: ({ appointmentId, ...body }) => ({
        url: `Appointments/${appointmentId}/Attendance`,
        method: "PUT",
        body,
      }),
      // The mark IS the treatment count, so everything derived from it is stale once it changes.
      invalidatesTags: ["UserTreatmentProtocol"],
    }),

    patchAppointment: build.mutation<
      any,
      IPatchAppointmentRequest
    >({
      query: ({ id, ...body }) => ({
        url: `Appointments/${id}`,
        method: "PATCH",
        body: [
          ...(body.appointmentDate ? [{ op: "replace", path: "/appointmentDate", value: body.appointmentDate }] : []),
          ...(body.startTime ? [{ op: "replace", path: "/startTime", value: body.startTime }] : []),
          ...(body.endTime ? [{ op: "replace", path: "/endTime", value: body.endTime }] : []),
          ...(body.therapistsId ? [{ op: "replace", path: "/therapistsId", value: body.therapistsId }] : []),
          ...(body.therapistsGuid ? [{ op: "replace", path: "/therapistsGuid", value: body.therapistsGuid }] : []),
          ...(body.mediaId ? [{ op: "replace", path: "/mediaId", value: body.mediaId }] : []),
          ...(body.treatmentRoomId ? [{ op: "replace", path: "/treatmentRoomId", value: body.treatmentRoomId }] : []),
          ...(body.comments ? [{ op: "replace", path: "/comments", value: body.comments }] : []),
          ...((body as any).statusId !== undefined ? [{ op: "replace", path: "/statusId", value: (body as any).statusId }] : []),
        ],
      }),
      invalidatesTags: ['GoogleCalendarEvents'],
    }),
    getUserComments: build.query<IUserComment[], string>({
      query: (userGuid) => `user/GetUserComments/${userGuid}`,
      providesTags: (result, _err, userGuid) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: "UserComments" as const, id })),
            { type: "UserComments", id: `LIST-${userGuid}` },
          ]
          : [{ type: "UserComments", id: `LIST-${userGuid}` }],
    }),
    postUserComment: build.mutation<
      Pick<IUserComment, "id" | "comment" | "createdOn">,
      IPostUserCommentDto
    >({
      query: (body) => ({
        url: "user/PostUserComment",
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _err, dto) => [
        { type: "UserComments", id: `LIST-${dto.usersGuid}` },
      ],
    }),
    patchUserComment: build.mutation<
      Pick<IUserComment, "id" | "comment" | "createdOn">,
      { id: number; body: IPatchUserCommentDto }
    >({
      query: ({ id, body }) => ({
        url: `user/PatchUserComment/${id}`,
        method: "PATCH",
        body,
      }),
      // Invalidate the specific comment so any list containing it refetches
      invalidatesTags: (_result, _err, { id }) => [
        { type: "UserComments", id },
      ],
    }),
    getIceServers: build.query<{ iceServers: TIceServer[] }, void>({
      query: () => ({
        url: `VideoCall/GetIceServers`,
        method: "GET",
      }),
    }),
    // Series management
    getSeriesAppointments: build.query<
      Array<{
        id: number;
        appointmentDate: string | null;
        startTime: string | null;
        endTime: string | null;
        statusId: number | null;
        seriesId: string;
      }>,
      string
    >({
      query: (seriesId) => `Appointments/Series/${seriesId}`,
      providesTags: (_result, _err, seriesId) => [{ type: "AppointmentSeries" as const, id: seriesId }],
    }),
    extendSeries: build.mutation<{ success: boolean; added: number }, { seriesId: string; count: number }>({
      query: ({ seriesId, count }) => ({
        url: `Appointments/Series/${seriesId}/Extend?count=${count}`,
        method: "POST",
      }),
      invalidatesTags: (_result, _err, { seriesId }) => [
        { type: "AppointmentSeries" as const, id: seriesId },
        'GoogleCalendarEvents',
      ],
    }),

    // ── Program-based series (cubes) — program-driven equivalents of the seriesId flow ──
    getProgramSessions: build.query<IProgramSessionsResponse, number>({
      query: (programId) => `Appointments/Programs/${programId}/Sessions`,
      providesTags: (_result, _err, programId) => [
        { type: "AppointmentProgramSessions" as const, id: programId },
      ],
    }),
    addProgramSessions: build.mutation<
      IProgramSessionsResponse,
      { programId: number; count: number }
    >({
      query: ({ programId, count }) => ({
        url: `Appointments/Programs/${programId}/Sessions?count=${count}`,
        method: "POST",
      }),
      invalidatesTags: (_result, _err, { programId }) => [
        { type: "AppointmentProgramSessions" as const, id: programId },
        'GoogleCalendarEvents',
      ],
    }),
    deleteProgramSession: build.mutation<
      IProgramSessionsResponse,
      { programId: number; appointmentId: number }
    >({
      query: ({ programId, appointmentId }) => ({
        url: `Appointments/Programs/${programId}/Sessions/${appointmentId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _err, { programId }) => [
        { type: "AppointmentProgramSessions" as const, id: programId },
        'GoogleCalendarEvents',
      ],
    }),
    getProgramConfig: build.query<IProgramConfig, number>({
      query: (programId) => `Appointments/Programs/${programId}/Config`,
    }),
    convertToSeries: build.mutation<
      IProgramSessionsResponse,
      { appointmentId: number; body: IConvertToSeriesRequest }
    >({
      query: ({ appointmentId, body }) => ({
        url: `Appointments/${appointmentId}/ConvertToSeries`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['GoogleCalendarEvents'],
    }),

    getUserEntitlements: build.query<IGetUserEntitlementsResponse, void>({
      query: () => ({
        url: `/user/me/entitlements`,
        method: "GET",
      }),
    }),

    getClientFiles: build.query<TClientFile[], string>({
      query: (patientUserGuid) => ({
        url: `Files/GetClientFiles/${patientUserGuid}`,
        method: "GET",
      }),
    }),

  }),
});

export const {
  useUpdateUserStatusMutation,
  useGetUserQuery,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useGetAllGendersQuery,
  useGetUserDocumentsQuery,
  useGetPendingReportsQuery,
  useLazyGetPendingReportsQuery,
  useLazyGetUserQuery,
  useUpdateUserMutation,
  useDeleteUserAvatarMutation,
  useUpdateTherapistInfoMutation,
  useUploadTherapistIntroVideoMutation,
  useUpdateTherapistIntroVideoLinkMutation,
  useDeleteTherapistIntroVideoMutation,
  useUpdateAboutMutation,
  useTakeInquiryMutation,
  useTakeAllInquiriesOfTypeMutation,
  useFetchPrescriptionsQuery,
  useGetMainPageInfoQuery,
  useLazyGetMainPageInfoQuery,
  useGetReportQuestionsAndOptionsByQuestionnaireIdQuery,
  useLazyGetReportQuestionsAndOptionsByQuestionnaireIdQuery,
  useGetDefaultReportDataQuery,
  useLazyGetDefaultReportDataQuery,
  useInsertAllAnswersQuestionsMutation,
  useInsertAllAnswersQuestionsForGroupMutation,
  useAnalyzeIcdCodesMutation,
  useAnalyzeFullReportMutation,
  useGetAllQuestionnairesByUserIdQuery,
  useLazyGetAllQuestionnairesByUserIdQuery,
  useLazyGetMultipleQuestionnairesByUserIdAndCycleQuery,
  useAddMessageToScoreMutation,
  useGetMessageByUsersIdAndCycleQuery,
  useGetStatusesQuery,
  useGetMediasQuery,
  useGetMigzarsQuery,
  useGetGendersQuery,
  useLazyGetGendersQuery,
  useGetChatAppointmentsQuery,
  useLazyGetChatAppointmentsQuery,
  useAddChatAppointmentMutation,
  usePostInquiryUpdateMutation,
  useLazySendUserEnteredSMSToTherapistQuery,
  useUpdateChatAppointmentMutation,
  usePostTherapistAvailabilityMutation,
  useGetTherapistAvailabilityMutation,
  useGetAllAppointmentsQuery,
  useLazyGetAllAppointmentsQuery,
  useLazyGetTherapistAppointmentsQuery,
  useLazyGetTodayAppointmentsQuery,
  useGetGoogleCalendarStatusQuery,
  useGetGoogleCalendarAuthMutation,
  useGoogleCalendarOAuthCallbackMutation,
  useDisconnectGoogleCalendarMutation,
  useCreateAppointmentMutation,
  useCreateAppointmentFastMutation,
  useGetAllOpenTreatmentPlansMutation,
  useGetAllOpenTreatmentPlansByUserGuidMutation,
  useGetAppointmentsProgramsTherapistsMutation,
  useGetAppointmentsProgramsUnavailableTherapistsMutation,
  useUpdateTherapistTakingTreatmentPlanMutation,
  useAlternativeAppointmentProgramDateMutation,
  useGetAllAppointmentsInProgramMutation,
  useCancleAppointmentProgramMutation,
  usePostAppointmentProgramMutation,
  useChangeAppointmentByCalendarMutation,
  useLazySendSMSToChatQuery,
  useUploadFileMutation,
  useUploadUserAvatarMutation,
  usePostFileMutation,
  usePostSupportMessageMutation,
  useGetRRMListMutation,
  useGetQuestionnaiersButtonsMutation,
  useAddUserMutation,
  useLazyGetUsersByCompanyIdWithRecommendsQuery,
  useChangePasswordMutation,
  useAdminResetUserPasswordMutation,
  usePostTreatmentPlanUpdatesMutation,
  useGetAllUpdatesForAppointmentProgramMutation,
  useLazyGetCurrentQuestionnaireByTypeQuery,
  useLazyGetUserMaxCycleByTypeQuery,
  useValidatePasswordMutation,
  useLazyGetAudioAnswerByGuidAndQuestionIdQuery,
  useGetUnSeenAppointmentsProgramQuery,
  useLazyGetUnSeenAppointmentsProgramQuery,
  useUpdateUnSeenAppointmentsProgramQuery,
  useLazyGetAllMetaTablesQuery,
  useLazyGetConsentStatusQuery,
  useRequestConsentMutation,
  useProcessConsentMutation,
  useTherapistsSpecializationsDMLMutation,
  useTherapistsSpecializations2TherapistsDMLMutation,
  useGetClientAnalysisQuery,
  useGetUserByIdQuery,
  useDeleteMeetingRecordsMutation,
  useGetUserMeetingRecordsMutation,
  useGetMeetingRecordsListQuery,
  useLazyGetMeetingRecordsListQuery,
  useGetClinicalFindingsQuery,
  useGetMeetingRecordStatusQuery,
  useLazyGetMeetingRecordStatusQuery,
  useUpdateMeetingSummaryMutation,
  useUpdateMeetingRecordAppointmentLinkMutation,
  useExportMeetingSummaryToPdfMutation,
  useGetProtocolsByCompanyQuery,
  useLazyGetProtocolsByCompanyQuery,
  useGetTreatmentRoomsQuery,
  useLazyGetTreatmentRoomsQuery,
  useUpdateUnavailableTherapistTakingTreatmentPlanMutation,
  useGetCompanyAppointmentsProgramsMutation,
  useGetCompanyByIdQuery,
  useLazyGetCompanyByIdQuery,
  useGetTreatmentGroupsQuery,
  useGetAvailableOpenTreatmentPlansByTherapistGuidMutation,
  useGetAdminMessagesQuery,
  useGetTherapistsQuestionsReportsQuery,
  useLazyGetTherapistsQuestionsReportsQuery,
  useLazyGetQuestionnaireAnswersForEditQuery,
  useGetAllCitiesQuery,
  useGetClinicalUserSummaryQuery,
  useGetUserTablePermissionsQuery,
  // Cancel Appointment
  useGetCancelAppReasonsQuery,
  useLazyGetCancelAppReasonsQuery,
  useCancelAppointmentMutation,
  // Edit Appointment
  useValidateAppointmentChangeMutation,
  usePatchAppointmentMutation,
  useSetAppointmentAttendanceMutation,
  useGetPendingHotlineQuestionnaireQuery,
  useUpdateAppointmentDeviceMutation,
  useGetCompanyDevicesQuery,
  useLazyGetCompanyDevicesQuery,
  // Series management
  useGetSeriesAppointmentsQuery,
  useLazyGetSeriesAppointmentsQuery,
  useExtendSeriesMutation,
  // Program-based series (cubes)
  useGetProgramSessionsQuery,
  useAddProgramSessionsMutation,
  useDeleteProgramSessionMutation,
  useLazyGetProgramConfigQuery,
  useConvertToSeriesMutation,
  useGetTherapistQuestionnairesForAutoFillQuery,
  useLazyGetTherapistQuestionnairesForAutoFillQuery,
  useAutoFillActionReportMutation,
  useLazyGetPendingRecordingSessionsQuery,
  useDismissRecordingSessionMutation,
  useFinalizeRecoveredSessionMutation,
  useFinalizeCallUploadMutation,
  // Retry Failed Meeting Records
  useRetryMeetingRecordMutation,
  // Reprocess Individual Stage
  useReprocessMeetingRecordStageMutation,
  useGetUserCommentsQuery,
  usePostUserCommentMutation,
  usePatchUserCommentMutation,
  useGetIceServersQuery,
  useGetUserEntitlementsQuery,
  useGetClientFilesQuery,
} = userApi;
